import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class DocumentClassificationDataService {

  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService) { }

  /**
   * Agregar una clasificación de documentos
   *
   * @param {ClasificacionPredeterminada} documentClassification
   * @returns {Promise<boolean>}
   * @memberof DocumentClassificationDataService
   */
  addDocumentClassification(documentClassification: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminDocument'),
       documentClassification).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Clasificación agregada correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Modificar una clasificación de documentos
   *
   * @param {number} id
   * @param {ClasificacionPredeterminada} documentClassification
   * @returns {Promise<boolean>}
   * @memberof DocumentClassificationDataService
   */
  updateDocumentClassification(id: number, documentClassification: FormData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminDocument', [id]), documentClassification).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Clasificación modificada correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Eliminar una clasificación de documentos
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof DocumentClassificationDataService
   */
  deleteDocumentClassification(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('adminDocument', [id])).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Clasificación eliminada correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Servicio para descargar los documentos de generación
   *
   * @param {number} idHistoryDocumento
   * @returns {Observable<any>}
   * @memberof DocumentClassificationDataService
   */
  dowloadFileDocumentGeneration(idDocument: number): Observable<any> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get(this.api.get('adminDocumentGeneration', [idDocument]), {
          observe: 'response'
        })
        .subscribe(
          res => {
              obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              if (err.status === 500) {
                this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
              } else {
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
            }
            obs.error(err);
          }
        );
    });
  }

  /**
   * Servicio para descargar los documentos de vista previa
   *
   * @param {number} idHistoryDocumento
   * @returns {Observable<any>}
   * @memberof DocumentClassificationDataService
   */
  dowloadFileDocumentPreviewDocument(idDocument: number): Observable<any> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get(this.api.get('adminDocumentPreviewDocument', [idDocument]), {
          observe: 'response'
        })
        .subscribe(
          res => {
              obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              if (err.status === 500) {
                this.toastr.error('No se pudo realizar la petición al servidor.', 'Ocurrió un error');
              } else {
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/document-classification/shared/document-classification-data.service.ts